export default {
    collecteById: state => identifiant => {
        return state.collectes.find(collecte => collecte.identifiant === identifiant)
    },
    objectifByCollecteIdAnId: (state, getters) => (collecteIdentifiant, identifiant) => {
        let collecte = getters.collecteById(collecteIdentifiant)
        if (collecte && collecte.listeObjectifs) {
            return collecte.listeObjectifs.find(o => o.identifiant === identifiant)
        }
        return null
    }
}